import React, { useState } from 'react';
import OpenInNewIconMui from '@mui/icons-material/OpenInNew';

import Button from '~/components/core/Atomic/Buttons/Button';
import { useCms } from '~/components/hooks/useCms';
import HoverActionField from '~/components/HoverActionField';
import type { ClaimPolymorph } from '~/components/types/claim-types';
import type { Exposure } from '~/server_shared/swagger/data-contracts';
import { reportErrorInProductionOrThrow } from '~/Utils';

import { isExposureWriteDisabled } from '../ExposureUtils';

import IncomeProtectionScreenOrCreationDialog from './IncomeProtectionScreenOrCreationDialog';
import TEXTS from './texts';

const exposureHasId = (exposure: Exposure): exposure is Exposure & { id: number } => {
  return exposure.id !== undefined && exposure.id !== null;
};

const IncomeProtectionDamageAssessmentContainer = ({
  exposure,
  claim,
  linkVariant = 'hover',
}: {
  exposure: Exposure;
  claim: ClaimPolymorph;
  linkVariant?: 'button' | 'hover';
}) => {
  const { user } = useCms();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!exposureHasId(exposure)) {
    reportErrorInProductionOrThrow(new Error('Exposure ID is required for Income Protection Settings Dialog'));
    return null;
  }

  const viewOnly = isExposureWriteDisabled(exposure, user);

  return (
    <>
      {linkVariant === 'button' ? (
        <Button color="primary" onClick={() => setIsDialogOpen(true)} variant="text" endIcon={<OpenInNewIconMui />}>
          {TEXTS.view}
        </Button>
      ) : (
        <HoverActionField icon={OpenInNewIconMui} permanent onAction={() => setIsDialogOpen(true)}>
          <span className="sr-only">{TEXTS.viewOrCreateSettings}</span>
        </HoverActionField>
      )}
      {isDialogOpen && (
        <IncomeProtectionScreenOrCreationDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          exposure={exposure}
          claim={claim}
          viewOnly={viewOnly}
        />
      )}
    </>
  );
};

export default IncomeProtectionDamageAssessmentContainer;
